import styled from 'styled-components';

const DefaultWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export { DefaultWrapper };



// WEBPACK FOOTER //
// ./src/components/Layout/DefaultWrapper.jsx